import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery, useMutation } from '@apollo/client';
import { TextInput } from '@guildeducationinc/recess';
import { TEST_FILTER } from '@src/graphql/queries/filter';
import _ from 'lodash';
import { EnumPicker, FilterBuilder, MessageType, Messages, SAVE_FILTER, TrackableButton, emptyFilter, useLocale, } from 'pe-core-frontend';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { EntityType } from '../../types';
export const Filter = (props) => {
    const { clientId } = useParams();
    const { t } = useLocale();
    const [filter, setFilter] = useState(props.value ?? {
        ...emptyFilter,
        clientId: Number(clientId),
    });
    const [messages, setMessages] = useState([]);
    const [saveFilter] = useMutation(SAVE_FILTER);
    const [testFilterQuery, testFilterResult] = useLazyQuery(TEST_FILTER);
    useEffect(() => {
        if (testFilterResult.data) {
            setMessages([
                {
                    type: MessageType.SUCCESS,
                    value: 'filter.test.success.message',
                    params: {
                        count: testFilterResult.data.testFilter.found,
                        total: testFilterResult.data.testFilter.total,
                    },
                },
            ]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testFilterResult]);
    const handleSave = async () => {
        // validate
        // save
        await saveFilter({
            variables: {
                input: {
                    ..._.omit(filter, ['id', 'createdAt', 'updatedAt', '__typename']),
                    id: filter.id ? filter.id : null,
                },
            },
        });
        // message
        setMessages([{ type: MessageType.SUCCESS, value: 'filter.saved' }]);
    };
    const handleTest = async () => {
        await testFilterQuery({
            variables: {
                input: {
                    ..._.omit(filter, ['id', 'createdAt', 'updatedAt', '__typename']),
                    id: filter.id ? filter.id : null,
                },
            },
        });
    };
    return (_jsxs("div", { children: [_jsx("h4", { className: 'text-3xl pb-3', children: t('Filter') }), _jsxs("div", { className: 'flex gap-1', children: [_jsx(TrackableButton, { enText: 'Save', tag: 'filters', buttonSize: 'small', onClick: handleSave, children: t('Save') }), _jsx(TrackableButton, { enText: 'Test', tag: 'filters', buttonSize: 'small', onClick: handleTest, children: t('Test') }), _jsx(TrackableButton, { enText: 'Cancel', tag: 'filters', Component: Link, buttonSize: 'small', appearance: 'outline', intent: 'danger', onClick: props.onComplete, children: t('Cancel') })] }), _jsxs("div", { children: [_jsx(Messages, { messages: messages, onClose: () => setMessages([]) }), _jsxs("div", { className: 'flex flex-col gap-3', children: [_jsx(TextInput, { label: '', placeholder: 'Name', value: filter.name, onChange: e => setFilter({ ...filter, name: e.target.value }) }), _jsx(EnumPicker, { placeholderKey: 'filter.select.return_entity_type', enumType: EntityType, labelPrefix: 'metadata.entityType', onChange: value => setFilter({ ...filter, returnType: value }), value: filter.returnType }), _jsx(FilterBuilder, { clientId: filter.clientId, entityEnumType: EntityType, criteria: filter.criteria, onChange: value => setFilter({ ...filter, criteria: value }), onError: messages => setMessages(messages), debug: true })] })] })] }));
};
